import { Modal, Input, Spin, Table } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import { getMTSColumns } from "./columnDefinitions";

const MakeToStockModal = ({
  mtsModalVisible,
  setMtsModalVisible,
  setChooseProductsData,
  searchTextStock,
  setSearchTextStock,
  setLoading,
  loading,
  handleSearchedStock,
  handleStockScroll,
  tableRef,
  chooseProductsData,
  updateChooseProductsData,
  handleChooseProductSelect,
}) => {
  const columns = getMTSColumns({ updateChooseProductsData, handleChooseProductSelect });

  return (
    <Modal
      title="Select Product for Production"
      open={mtsModalVisible}
      onCancel={() => {
        setMtsModalVisible(false);
        setChooseProductsData([]);
        setSearchTextStock("");
        setLoading(false);
      }}
      footer={null}
      width={900}
      centered={true}
      maskClosable={true}
      styles={{ body: { padding: "16px" } }}
    >
      <Input
        style={{ width: "50%" }}
        placeholder="Search for products by code/name"
        value={searchTextStock}
        onChange={(e) => setSearchTextStock(e.target.value)}
        onPressEnter={() => handleSearchedStock()}
      />
      <Spin spinning={loading}>
        <Scrollbars ref={tableRef} className="productionScroll" onScrollFrame={handleStockScroll}>
          <Table
            className="sm-cart-table-pos"
            tableLayout="fixed"
            columns={columns}
            dataSource={chooseProductsData}
            pagination={false}
            rowKey="id"
            style={{ marginTop: "8px" }}
          />
        </Scrollbars>
      </Spin>
    </Modal>
  );
};

export default MakeToStockModal;
